var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"school-admin"},[_c('admin-template',_vm._b({},'admin-template',_vm.templateConfig,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }